<div class="mb-3">
  <div class="p-3 border border-dark">
    <form [formGroup]="commentsForm" id="comments-form">
      <div>
        <label for="comments">Add An Optional Note</label>
        <textarea id="comments"
                  type="text"
                  class="form-control"
                  aria-describedby="optional note"
                  formControlName="commentsControl"
                  name="comments"
                  rows="5"
                  placeholder="Example: &quot;For John Smith, home use&quot;"></textarea>
      </div>
    </form>
  </div>
</div>
